import { MutationOptions, useMutation, useQueryClient } from "react-query";
import { APIError, APIResponse, postFormData } from "../api";
import { API_URL } from "../api";

function useUtilityBillUpload<T>(
  options?: MutationOptions<APIResponse<T>, APIError, Record<any, any>>
) {
  const client = useQueryClient();
  const {
    isLoading: uploadingUtilityBill,
    isError: isUtilityBillUploadError,
    error: idUploadError,
    mutate: uploadUtilityBill,
  } = useMutation(
    (variables: Record<any, any>) => {
      /** Laravel `uploadUtilityImage` → `utility_image_1` / `utility_type_1` (not compliance_image_*). */
      const url = API_URL + "/account/user/account/upload-utility-image";

      const file = variables.file as File;
      const formData = new FormData();
      formData.append(
        "utility_type_1",
        variables.utility_type_1 ?? "Utility Bill"
      );
      formData.append("utility_image_1", file, file.name);

      const headers = {
        accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };

      const options = {
        headers: headers,
      };

      return postFormData(url, formData, options);
    },
    {
      ...options,
      onSettled() {
        client.invalidateQueries("profile");
      },
    }
  );

  return {
    uploadUtilityBill,
    isUtilityBillUploadError,
    idUploadError,
    uploadingUtilityBill,
  };
}

export default useUtilityBillUpload;
